import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  useToast
} from '@chakra-ui/react';
import Form from '@rjsf/chakra-ui';
import validator from "@rjsf/validator-ajv8";
import { getDeletedValues } from '../../../util/helper';
import { getEventMasterlistIntroductionData, updateEventMasterlistData } from '../../../services/EventMasterlist';
import CKEditorWidget from '../../../CommonComponents/CKEditorWidget';
import { RjsfSubmitButton } from '../../../RJSFCommonSchemas';
import FormLoader from '../../../CommonComponents/FormLoader';
import { showErrorToast, showSuccessToast } from "../../../util/errorHandler";


const Preface = () => {
  const { alias } = useParams();
  const [basicFieldData, setBasicFieldData] = useState({});
  const [quickSave, setQuickSave] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();


  const schema = {
    "title": "Architectural Landmark fields",
    "description": "",
    "type": "object",
    "properties": {
      "preface": {
        "type": "string",
        "title": "Preface",
      },
    }
  }

  const uiSchema = {
    ...RjsfSubmitButton(isSubmitting),
    preface: { 
      "ui:widget": CKEditorWidget,
      "ui:options": {
        placeholder: "Enter preface content...",
        height: "400px"
      }
    },
  };

  const formData = basicFieldData;

  // Fetch initial data
  useEffect(() => {
    const getPrefaceData = async () => {
      try {
        if (alias) {
          const result = await getEventMasterlistIntroductionData(alias, 'preface');
          if (result) {
            setBasicFieldData(result?.[0]);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
                showErrorToast(toast, "Failed to fetch film data");
      } finally {
        setIsLoading(false);
      }
    };

    getPrefaceData();
  }, [alias, toast, quickSave]);

  // Submit updated data
  const handleSubmit = async (formData) => {

    const deletedValues = getDeletedValues(basicFieldData, formData);

    try {
      if (alias) {
        setIsSubmitting(true);
        const result = await updateEventMasterlistData(alias, formData, deletedValues);

        if (result?.success) {
          setQuickSave(prev => !prev);

                    showSuccessToast(toast, "Data updated successfully");
        }

      }
    } catch (error) {
      console.error('Error updating film data:', error);
            showErrorToast(toast, "Failed to update film data");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box maxW="auto">
      {isLoading ? (
        <FormLoader />
      ) : (
          <Form schema={schema} uiSchema={uiSchema} formData={formData} validator={validator} onSubmit={(e) => handleSubmit(e.formData)}>
    </Form>
      )}
    </Box>

  );
};

export default Preface;